import { Box, Button } from '@mui/material';
import styled from 'styled-components';

export const ButtonTabWrapper = styled(Box)(() => ({
  display: 'flex',
  gap: '10px'
}));

export const RoundedButton = styled(Button).attrs((props: any) => ({
  color: 'primary',
  style: {
    backgroundColor: props.backgroundColor,
    color: props.textColor,
    boxShadow: props.boxShadow
  }
}))<{
  backgroundColor?: string;
  textColor?: string;
  boxShadow: string;
}>({
  width: '100%',
  maxWidth: '100%',
  borderRadius: '6px !important',
  '@media (min-width:600px)': {
    width: 'auto',
    maxWidth: '200px'
  },
  textWrap: 'nowrap'
});
